module.exports = __webpack_public_path__ + "media/old_images/arrow-down-brown-f3e975dc.svg";